export default function initYMap() {
    if (window.ymaps === undefined) {
        return;
    }
    ymaps.ready(ready);
}

const CENTER = [56.83801, 60.597465];
const MARK_SRC = "site-assets/css/themes/base/base/images/map_point.svg";
const MARK_SIZE = [36, 36];
const MARK_OFFSET = [-16, -38];

function ready() {
    const maps = document.querySelectorAll(".yandex-map");
    for (let ymap of maps) {
        const id = ymap.getAttribute("id");
        if (id === undefined || id.length == 0) {
            continue;
        }

        const dataUrl = ymap.getAttribute("data-url");
        const query = window.location.search;
        if (dataUrl && dataUrl.length > 0) {
            loadMapByDataUrl(id, dataUrl, query);
            continue;
        }

        const dataAddress = ymap.getAttribute("data-address");
        const dataCoordinates = ymap.getAttribute("data-coordinates");
        if (dataCoordinates && dataCoordinates.length > 0) {
            loadMapByCoordinates(id, dataCoordinates, {
                address: dataAddress,
            });
            continue;
        }

        if (dataAddress && dataAddress.length > 0) {
            loadMapByAddress(id, dataAddress);
            continue;
        }
    }
}

function loadMapByDataUrl(id, dataUrl, query) {
    fetch(dataUrl + query)
        .then((resp) => resp.json())
        .catch((err) => console.error(err))
        .then((answ) => {
            const ymapInstance = new ymaps.Map(id, {
                center: CENTER,
                zoom: 10,
                controls: ["zoomControl"],
            });

            for (let office of answ) {
                let pt = yPlaceMark(office);
                ymapInstance.geoObjects.add(pt);
            }

            ymapInstance
                .setBounds(ymapInstance.geoObjects.getBounds(), {
                    checkZoomRange: true,
                    zoomMargin: 20,
                })
                .then(function () {
                    if (ymapInstance.getZoom() > 15) {
                        ymapInstance.setZoom(15);
                    }
                });
        });
}

function loadMapByCoordinates(id, coordinates, office) {
    if (!Array.isArray(coordinates)) {
        coordinates = coordinates.replace(" ", "").split(",");
    }

    const ymapInstance = new ymaps.Map(id, {
        center: coordinates,
        zoom: 14,
        controls: ["zoomControl"],
    });

    if (office) {
        office.coordinates = coordinates;
        let pt = yPlaceMark(office);
        ymapInstance.geoObjects.add(pt);
    }
}

function loadMapByAddress(id, address) {
    ymaps.geocode(address).then(
        (res) => {
            let coordinates = res.geoObjects.get(0).geometry.getCoordinates();
            if (coordinates) {
                loadMapByCoordinates(id, coordinates, {
                    address: address,
                });
            }
        },
        (err) => {
            console.log(err);
        }
    );
}

function yPlaceMark(office) {
    const balloonLayout = ymaps.templateLayoutFactory.createClass(
        `
            <div class="yandex-map-popover">
                <div class="tail"></div>
                <div class="popover-inner">
                    <a class="close" href="#"></a>
                    $[[options.contentLayout]]
                </div>
            </div>
        `,
        {
            build: function () {
                this.constructor.superclass.build.call(this);
                this._$element = $(
                    ".yandex-map-popover",
                    this.getParentElement()
                );

                this.applyElementOffset();
                this._$element
                    .find(".close")
                    .on("click", $.proxy(this.onCloseClick, this));
            },

            clear: function () {
                this._$element.find(".close").off("click");
                this.constructor.superclass.clear.call(this);
            },

            onSublayoutSizeChange: function () {
                balloonLayout.superclass.onSublayoutSizeChange.apply(
                    this,
                    arguments
                );

                if (!this._isElement(this._$element)) {
                    return;
                }

                this.applyElementOffset();
                this.events.fire("shapechange");
            },

            applyElementOffset: function () {
                var left = -(this._$element[0].offsetWidth / 2) - 36;
                var right = -(this._$element[0].offsetHeight / 2) + 58;
                this._$element.css({
                    left: left,
                    top: right,
                });
            },

            onCloseClick: function (e) {
                e.preventDefault();
                this.events.fire("userclose");
            },

            getShape: function () {
                if (!this._isElement(this._$element)) {
                    return balloonLayout.superclass.getShape.call(this);
                }

                var position = this._$element.position();

                return new ymaps.shape.Rectangle(
                    new ymaps.geometry.pixel.Rectangle([
                        [position.left, position.top],
                        [
                            position.left + this._$element[0].offsetWidth,
                            position.top +
                                this._$element[0].offsetHeight +
                                this._$element.find(".tail")[0].offsetHeight,
                        ],
                    ])
                );
            },

            _isElement: function (element) {
                return element && element[0] && element.find(".tail")[0];
            },
        }
    );

    var content = [];
    if (office.caption) {
        content.push(`<h3 class="popover-title">$[properties.balloonHeader]</h3>`);
    }
    if (office.address) {
        content.push(`<div class="popover-content address">$[properties.balloonAddress]</div>`);
    }
    if (office.schedule) {
        content.push(`<div class="popover-content schedule">$[properties.balloonSchedule]</div>`);
    }
    if (office.contacts) {
        content.push(`<div class="popover-content contacts">$[properties.balloonContacts]</div>`);
    }

    // Создание вложенного макета содержимого балуна.
    const balloonContentLayout = ymaps.templateLayoutFactory.createClass(
        `
            <div class="popover-content-container">
                ${content.join("")}
            </div>
        `
    );

    return new ymaps.Placemark(
        office.coordinates,
        {
            balloonHeader: office.caption,
            balloonAddress: office.address,
            balloonSchedule: office.schedule,
            balloonContacts: office.contacts,
        },
        {
            balloonShadow: false,
            balloonLayout: balloonLayout,
            balloonContentLayout: balloonContentLayout,
            balloonPanelMaxMapArea: 0,
            hideIconOnBalloonOpen: false,
            balloonOffset: [3, -40],
            iconLayout: "default#image",
            iconImageHref: MARK_SRC,
            iconImageSize: MARK_SIZE,
            iconImageOffset: MARK_OFFSET,
        }
    );
}
